var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-send';
                    var viewUrl = 'sprite.svg#view-icon-send';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 14 12',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };